import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import type { ModuleDeviceRequirements } from "features/module/types";

import styles from "./components/common.module.scss";

export const assetParameters = {
  default: {
    width: getDimensionFromCSSVar(styles.defaultimagewidth),
    height: getDimensionFromCSSVar(styles.defaultimageheight),
    fit: Fit.INSIDE
  }
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 950,
  desktopOnly: false
};
